import Vue from "vue"
import App from "./App.vue"
import router from "./router"
import Router from "vue-router"
import store from "./store"
import "swiper/dist/css/swiper.css"
import VueAwesomeSwiper from "vue-awesome-swiper"
import ElementUI from "element-ui"
import "element-ui/lib/theme-chalk/index.css"
import "./common/reset.css"
import "./common/common.css"

import "babel-polyfill"

require("babel-polyfill")

import VideoPlayer from "vue-video-player"

require("video.js/dist/video-js.css")
require("vue-video-player/src/custom-theme.css")
// // 引入富文本编辑器
import "quill/dist/quill.snow.css"
import "quill/dist/quill.bubble.css"

import config from "@/util/config"

//

Vue.use(VideoPlayer)

Vue.use(VueAwesomeSwiper)
Vue.use(ElementUI)
Vue.config.productionTip = false

// const routerPush = Router.prototype.push
// Router.prototype.push = function push(location) {
//   return routerPush.call(this, location).catch(error=> error)
// }

router.beforeEach((to, from, next) => {
  //路由发生变化修改页面meta
  console.log(to.meta.content)
  if (to.meta.content) {
    let head = document.getElementsByTagName("head")
    let meta = document.createElement("meta")
    document
      .querySelector('meta[name="description"]')
      .setAttribute("content", to.meta.content.description)
    meta.content = to.meta.content
    head[0].appendChild(meta)
  } else {
    let head = document.getElementsByTagName("head")
    let meta = document.createElement("meta")
    document
      .querySelector('meta[name="description"]')
      .setAttribute("content", "")
    meta.content = to.meta.content
    head[0].appendChild(meta)
  }
  next()
})

new Vue({
  router,
  store,
  VueAwesomeSwiper,
  render: function (h) {
    if (
      "-ms-scroll-limit" in document.documentElement.style &&
      "-ms-ime-align" in document.documentElement.style
    ) {
      window.addEventListener(
        "hashchange",
        () => {
          var currentPath = window.location.hash.slice(1)
          if (this.$route.path !== currentPath) {
            this.$router.push(currentPath)
          }
        },
        false
      )
    }
    return h(App)
  }
}).$mount("#app")
